const HOTEL_RESCHEDULE_ERROR_MAP = {
  ORDER_IS_PAID: '已付款訂單不可改期',
  HOTEL_ORDER_IS_PAID: '已付款訂單不可改期',
  PAID_ORDER_CANNOT_RESCHEDULE: '已付款訂單不可改期',
  ROOM_ID_PET_MISMATCH: '選擇的房型與寵物數量或種類不符，請重新選擇',
  ROOM_PET_CATEGORY_MISMATCH: '選擇的房型與寵物數量或種類不符，請重新選擇',
  ROOM_PET_MISMATCH: '選擇的房型與寵物數量或種類不符，請重新選擇',
}

const PAID_STATUS_CODES = new Set([400])
const MISMATCH_STATUS_CODES = new Set([422])

export function mapHotelRescheduleErrorMessage(status, statusCode) {
  const key = String(status || '').trim()
  if (HOTEL_RESCHEDULE_ERROR_MAP[key]) return HOTEL_RESCHEDULE_ERROR_MAP[key]
  if (key.includes('已付款') && key.includes('改期')) return '已付款訂單不可改期'
  if (key.includes('不匹配') || key.includes('不符')) {
    return '選擇的房型與寵物數量或種類不符，請重新選擇'
  }

  const code = Number(statusCode)
  if (PAID_STATUS_CODES.has(code)) return '已付款訂單不可改期'
  if (MISMATCH_STATUS_CODES.has(code)) return '選擇的房型與寵物數量或種類不符，請重新選擇'

  return '修改日期失敗，請稍後再嘗試一次'
}
